import { FaCheck, FaTimes } from "react-icons/fa"; // Iconos equivalentes a FontAwesome
import { main } from "../../../assets/coach-assets/constants/colors";
import { fontType } from "../../../assets/extras";


const PlayerCard = ({
    delay,
    data,
    func,
    funcOut,
    onClick
}) => {

    //Funcion que formatea el nombre de los jugadores para que quepan en el recuadro
    const formatName = (nombre) => {
        let name = ""
        let cont = 0
        for(let i = 0; i < nombre.length; i++){
            name += nombre[i]
            cont ++

            if(cont == 17){
                break
            }
        }

        if(cont == 17){
            return name + "..."
        } else {
            return name
        }
    }

    return (
        <div style={styles.cont}>
            <div>
                <p
                    style={{ fontSize: 16, fontWeight: "bold", cursor: "pointer", fontFamily: fontType.text }}
                    onClick={() => onClick(data)}
                >
                    {formatName(data.nombre_jugador)}
                </p>
            </div>

            <div style={styles.right}>
                {data.queued === true ? (
                    <button
                        style={{ ...styles.button, backgroundColor: "darkred" }}
                        onClick={() => funcOut(delay, data.id)}
                    >
                        <FaTimes size={20} color="white" />
                    </button>
                ) : (
                    <button
                        style={{ ...styles.button, backgroundColor: main }}
                        onClick={() => func(delay)}
                    >
                        <FaCheck size={20} color="white" />
                    </button>
                )}
            </div>
        </div>
    )
}

const styles = {
  cont: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: "10px 15px",
    border: "1px solid #ddd",
    borderRadius: 8,
    marginBottom: 10
  },
  right: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  button: {
    padding: "8px 12px",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

export default PlayerCard